import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatComponent } from './chat/chat.component';
import { AngularFireModule } from '@angular/fire/compat'
import { environment } from '../../environments/environment';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms'
import { SharedModule } from '../shared/shared.module';

const routes: Routes = [
  { path: 'messages', component: ChatComponent }
];

@NgModule({
  declarations: [
    ChatComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    FormsModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    SharedModule
  ],
  exports: [
    ChatComponent
  ]
})
export class MessagesModule { }
